import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';;
import TextField from '@mui/material/TextField';;
import InfoButton from '../selectComponents/InfoButton';

export default function StateSelect(props) {
	const { setUserParams, userParams, setShowGoButton } = props;
	const [postals, setPostals] = useState("");

	const handleStateChange = (event) => {
		const newPostals = event.target.value.replace(" ","");
		setPostals(newPostals);
		setUserParams({...userParams, areaType: "state", area: newPostals});
		setShowGoButton(true);
	};

	useEffect(() => {
		const savedPostals = userParams.areaType === 'state' ? userParams.area : "";
		setPostals(savedPostals)
	}, []);

	return (
		<Box sx={{ mt: 0 }}>
			<TextField
				label="State(s)"
				value={postals}
				autoFocus
				sx={{ width: "12em", mt: 1 }}
				onChange={handleStateChange}
				InputProps={{endAdornment:(<InfoButton infoFor="postal" edge={false} />)}}
				inputProps={{ spellCheck: false }}
				helperText="Enter one or more state postal abbreviations"
			/>
		</Box>
	);
 };
